import {NoteSortingKey} from './types'

export const TAG_MAX_LENGTH = 28
export const MIN_ORGANIZATION_NAME_LENGTH = 3
export const MIN_SCREENNAME_LENGTH = 3
export const MAX_SCREENNAME_LENGTH = 30
export const MAX_FUZZY_MATCH_LENGTH = 10
export const MAX_BIO_LENGTH = 128
export const MIN_COLLECTION_NAME_LENGTH = 2
export const MAX_COLLECTION_NAME_LENGTH = 48
export const NOTE_SEARCH_MAX_PAGE_SIZE = 300
export const DEFAULT_SEARCH_SORT = NoteSortingKey.POPULAR_SCORE
export const TOTAL_TAG_COUNT = 10
export const MIN_PASSWORD_LENGTH = 8
export const MAX_PASSWORD_LENGTH = 64
export const MILLISECONDS_PER_MINUTE = 1000 * 60
export const MILLISECONDS_PER_HOUR = MILLISECONDS_PER_MINUTE * 60
export const MAX_DESCRIPTION_COUNT = 250
export const MAX_TITLE_COUNT = 100
export const TOP_TAG_COUNT = 200

export const TRENDING_NOTE_ACTIVITY_HOURS = 72
export const POPULAR_NOTE_ACTIVITY_HOURS = 24 * 30
export const TRENDING_NOTE_RECALC_MINUTES = 10
export const MAX_EVENTS_PER_NOTIFICATION = 2

// COMMENTS CONSTANTS
export const MIN_COMMENT_LENGTH = 3
export const MAX_COMMENT_LENGTH = 256
export const MAX_COMMENTS_PER_HOUR = 10
export const MAX_COMMENTS_PER_DAY = 30
export const COMMENTS_DEFAULT_PAGE_SIZE = 20
export const MAX_COMMENT_REPORT_REASON_LENGTH = 500

// Note Remix
export const NO_PARENT_NOTE_ID = 'NONE'

/** A browser opening a missing or hidden gallery note is sent to the marketing homepage with this `referrer`. */
export const GALLERY_NOTE_NOT_FOUND_REFERRER = 'gallery-note-not-found'
